import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import clsx from "clsx";

export const Scrollbar = ({
  children,
  className,
  onYReachStart,
  onScrollY,
}: any) => (
  <PerfectScrollbar
    className={clsx("scrollbars__main-container", className)}
    options={{
      suppressScrollX: false,
      wheelPropagation: false,
      wheelSpeed: 0.5,
    }}
    onTouchMove={(event) => {
      // event.preventDefault();
      event.stopPropagation();
    }}
    onDrag={(event) => {
      // event.preventDefault();
      event.stopPropagation();
    }}
    onScroll={(event) => {
      // event.preventDefault();
      event.stopPropagation();
    }}
    onYReachStart={() => {
      onYReachStart();
    }}
    onScrollY={(event) => {
      onScrollY(event);
    }}
  >
    {children}
  </PerfectScrollbar>
);
